import Vue from "vue";
/*GLOBAL COMPONENTS */
import UserName from "./components/userName.vue";
Vue.component("Greetings", UserName);

import BtnCobiTime from "./components/SimpleComponents/btnCobiTime.vue";
Vue.component("mybtn", BtnCobiTime);

// import TimePicker from "./components/SimpleComponents/TimePicker.vue";
// Vue.component("mytimepicker", TimePicker);
import TimePicker from "./components/SimpleComponents/TimePicker.vue";
Vue.component("mytimepicker", TimePicker);

import DatePicker from "./components/SimpleComponents/DatePicker.vue";
Vue.component("mydatepicker", DatePicker);
